import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { border } from "@smartsheet/design-tokens";
import { checkboxBorderTheme } from "../checkboxTheme";
var getSize = function getSize(props) {
  return props.size;
};
export var CheckmarkWrapper = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    // border color is managed from the CheckboxIcon component.\n    border-width: ", ";\n    border-style: solid;\n    border-radius: ", ";\n\n    box-sizing: border-box;\n    height: var(--smar--sds--checkbox--visual-size, ", "px);\n    width: var(--smar--sds--checkbox--visual-size, ", "px);\n\n    flex: none;\n"])), border.width20, function (_ref) {
  var themeMode = _ref.themeMode;
  return checkboxBorderTheme.borderRadius(themeMode);
}, getSize, getSize);
CheckmarkWrapper.displayName = "CheckboxWrapper";
//# sourceMappingURL=CheckmarkWrapper.js.map